import React, { Suspense } from 'react'
import {
  Anchor,
  Button,
  Div,
  Flex,
  Input,
  LoadingSpinner,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { useDebounce, useState } from 'src/hooks'
import { SponsorFragment } from 'src/graphql'
import SponsorSearchResult from './SponsorSearchResult'

const marketingCopy = {
  affiliate: {
    title: 'Who introduced you to Greener Still or any of its six companies?',
    body:
      'We provide compensation based on the sharing efforts of our Affiliates. Please find the Affiliate who shared our products with you to ensure they are given credit.',
    searchPlaceHolder: 'Search for your sponsor',
    anchorText: 'No one referred me',
  },
  customer: {
    title: 'Who showed you this product?',
    body:
      'We celebrate and give back to the people who invite others to experience our product.',
    searchPlaceHolder: 'Search for your friend',
    anchorText: 'I found your website on my own',
  },
}

const FindSponsor = (props: {
  onSelectedSponsor: (sponsorId: string) => void
  isAffiliateJoining?: boolean
}) => {
  const { onSelectedSponsor, isAffiliateJoining } = props
  const [search, setSearch] = useState<string>('')
  const debouncedSearch = useDebounce(search, 500)
  const [selectedSponsor, setSelectedSponsor] = useState<SponsorFragment>()
  const handleSelectSponsor = () => {
    if (selectedSponsor) {
      onSelectedSponsor(selectedSponsor.id)
    }
  }

  const { title, body, searchPlaceHolder, anchorText } = isAffiliateJoining
    ? marketingCopy.affiliate
    : marketingCopy.customer

  const handleNoSponsor = () => onSelectedSponsor('84109')

  return (
    <>
      <Flex width="100%" flexDirection={'column'}>
        <Text type="title" weight="semiBold">
          {title}
        </Text>
        <Spacer space="x1" />
        <Text type="body" weight="regular">
          {body}
        </Text>
        <Spacer space="x2" />
        <Div width={'100%'}>
          <Input
            type="search"
            onChange={setSearch}
            value={search}
            icon={'search'}
            placeholder={searchPlaceHolder}
            isFullWidth={true}
          />
        </Div>
        <Spacer space="x2" />
        <Div width="100%" maxHeight="310px" overflow="auto">
          <Suspense
            fallback={
              <Flex
                justifyContent="center"
                alignItems="center"
                height="205px"
                width="100%"
                overflow="hidden"
              >
                <LoadingSpinner size="large" />
              </Flex>
            }
          >
            <SponsorSearchResult
              search={debouncedSearch}
              selectedSponsor={selectedSponsor}
              setSelectedSponsor={setSelectedSponsor}
            />
          </Suspense>
        </Div>
        <Spacer space="x2" />
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          outset={{ top: 'auto' }}
        >
          <Div>
            <Button
              title={
                search.length === 0
                  ? searchPlaceHolder
                  : selectedSponsor
                  ? `Choose ${selectedSponsor.firstName}`
                  : `Choose a friend`
              }
              onClick={handleSelectSponsor}
              disabled={!selectedSponsor}
              fullWidth={true}
              hover={true}
              type={'primary'}
            />
          </Div>
          <Spacer space="x4" />
          <Anchor size="small" isDecorated={true} onClick={handleNoSponsor}>
            {anchorText}
          </Anchor>
        </Flex>
      </Flex>
    </>
  )
}

export default FindSponsor
